import { render, staticRenderFns } from "./LogoutConfirmation.vue?vue&type=template&id=68526312&"
import script from "./LogoutConfirmation.vue?vue&type=script&lang=js&"
export * from "./LogoutConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports